import { NS } from "../common/classes";

export const TREE = `${NS}-tree`;
export const TREE_ROOT = `${NS}-tree-root`;
export const TREE_NODE_LIST = `${NS}-tree-node-list`;

export const TREE_NODE = `${NS}-tree-node`;
export const TREE_NODE_CONTENT = `${TREE_NODE}-content`;
export const TREE_NODE_CHILD = `${TREE_NODE}-child`;
